'use strict';

module.exports = function (_ref) {
  var libp2p = _ref.libp2p;
  return function () {
    return Boolean(libp2p && libp2p.isStarted());
  };
};